<div class="wrapper">
  <div class="loading-wrap" *ngIf="isloading">
    <div class="loader"></div>
  </div>
  <div class="content-wrap {{route_path}} {{isCheckoutPage ? 'checkout-page' : ''}}">
    <app-header></app-header>
    <div class="content-body">
      <router-outlet (activate)="onActivate()"></router-outlet>

      <ng-container *ngIf="shouldShowOrderNowButton()">
        <button class="btn bg-brown1 text-white rounded-pill hover-bg-dark1 order-btn" (click)="onOrderOnlineClickedForRouting()">Order Now</button>
        <!-- <button class="btn bg-brown1 text-white rounded-pill hover-bg-dark1 order-btn" *ngIf="!isLocationSelected" (click)="onChoseLocationClickedForRouting()">Order Now</button> -->
        <!-- <button class="btn bg-brown1 text-white rounded-pill hover-bg-dark1 order-btn" *ngIf="isLocationSelected" routerLink="/order-online">Order Now</button> -->
      </ng-container>
    </div>
    <app-footer></app-footer>
  </div>
  <!-- <app-checkout-bar></app-checkout-bar> -->
  <app-cookie-policy></app-cookie-policy>
</div> 
     